/** Idioma suportado para traduções (packs, presets, etc.) */
export type TranslationLanguageCode = 'PT_BR' | 'EN' | 'ES';

/** Item de tradução enviado para a API */
export interface TranslationItem {
  languageCode: TranslationLanguageCode;
  description: string;
}

/** Configuração de idioma disponível */
export interface TranslationLanguageOption {
  code: TranslationLanguageCode;
  label: string;
}

export const TRANSLATION_LANGUAGES: TranslationLanguageOption[] = [
  { code: 'PT_BR', label: 'Português (Brasil)' },
  { code: 'EN', label: 'English' },
  { code: 'ES', label: 'Español' },
];
